module.exports = __webpack_public_path__ + "img/rd-doc.ba07ff6e.svg";